export class StringOperation
{
    static split(text: string): string[]
    {
        return text.split(/[\s;,|]+/).filter(x => x);
    }
    static format(string: string, ...args: string[]): string
    {
        return string.replace(/{(\d+)}/g, (match, index) =>
        {
            const arg = args[index];
            return typeof arg !== 'undefined' ? arg : match;
        });
    }
    static repair(value: string): string
    {
        if (value == null)
            value = '';
        value = value.replace(/\s\s+/gm, ' ');
        value = value.trim();
        return value;
    }
}